import '../assets/NcAppNavigationNew-D8_2ab9R.css';
import { N as NcButton } from "./NcButton-D6Swkr1k.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  components: {
    NcButton
  },
  props: {
    /**
     * Id of the button
     */
    buttonId: {
      type: String,
      required: false,
      default: ""
    },
    /**
     * Disabled state of the button
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Main text of the button
     */
    text: {
      type: String,
      required: true
    },
    /**
     * @deprecated use `variant` instead - will be removed with v9
     */
    type: {
      type: String,
      default: "primary",
      validator(value) {
        return ["primary", "secondary", "tertiary"].indexOf(value) !== -1;
      }
    },
    /**
     * The color variant to use.
     *
     * @default 'primary'
     */
    variant: {
      type: String,
      default: "primary",
      validator(value) {
        return ["primary", "secondary", "tertiary"].indexOf(value) !== -1;
      }
    }
  },
  emits: ["click"]
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "app-navigation-new" }, [_c("NcButton", { attrs: { "id": _vm.buttonId, "disabled": _vm.disabled, "variant": _vm.type !== "primary" ? _vm.type : _vm.variant }, on: { "click": function($event) {
    return _vm.$emit("click");
  } }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
    return [_vm._t("icon")];
  }, proxy: true }], null, true) }, [_vm._v(" " + _vm._s(_vm.text) + " ")])], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "6f255eb3"
);
const NcAppNavigationNew = __component__.exports;
export {
  NcAppNavigationNew as N
};
//# sourceMappingURL=NcAppNavigationNew-BOfIdgIu.mjs.map
